import useAct from 'FlowOverview/useAct'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import waitForDeferredResult from 'Shared/utils/waitForDeferredResult'
import Loading from 'Shared/components/Loading'

function RefreshTargets({ onComplete, onClose, entityName, refreshTargetFunction, onCommit = null }) {
  const [state, setState] = useState('loading_preview')
  const [added, setAdded] = useState(0)
  const [removed, setRemoved] = useState(0)

  async function commit() {
    setState('syncing')
    const { data: { deferredResultId } } = await refreshTargetFunction(false)
    try {
      const result = await waitForDeferredResult(deferredResultId)
      setAdded(result.added)
      setRemoved(result.removed)
      if (onCommit) { onCommit() }
      setState('done')
    } catch (error) {
      setState('error')
    }
  }

  useEffect(() => {
    (async function () {
      const { data: { deferredResultId } } = await refreshTargetFunction(true)
      const result = await waitForDeferredResult(deferredResultId)
      setAdded(result.added)
      setRemoved(result.removed)
      setState('preview')
    })()
  }, [])

  const buttonDisabled = added === 0 && removed === 0

  return <BackdropModal title="Refresh audience" open={true} onCancel={onClose}>
    <div className='wizard'>
      <div className='step'>
        {state === 'loading_preview' && <>
          <h3>Calculating changes</h3>
          <p>We're just working out how many people will be added to, and removed from this { entityName }.</p>
          <Loading />
        </>}
        {state === 'preview' && <>
          <h3>Here's what will happen</h3>
          <p className='bold'>{added} people will be added to this { entityName }</p>
          <p className='bold'>{removed} people will be removed from this { entityName }</p>
          <button className='button primary no-margin-left' onClick={commit} disabled={buttonDisabled}>Continue</button>
        </>}
        {state === 'syncing' && <>
          <h3>Your { entityName } is being updated</h3>
          <Loading />
        </>}
        { state === 'error' && <>
          <h3>There was an error</h3>
          <p className='error'>We couldn't refresh the audience for this { entityName }. Please try again or contact support.</p>
          <button className='button primary no-margin-left' onClick={onClose}>Close</button>
        </>}
        {state === 'done' && <>
          <h3>All done</h3>
          <button onClick={onComplete} className='primary button no-margin-left'>Back to my { entityName }</button>
        </>}
      </div>
    </div>
  </BackdropModal>
}

export default React.memo(RefreshTargets)
